import { FC, useState } from 'react';
import {
    Col,
    PageHeader,
    Row,
} from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

import { Variables } from './Variables';
import { Concepts } from './Concepts';

const Plan: FC = () => {
    const navigate = useNavigate();

    const location = useLocation();
    const plan = location.state;

    const onBackHandle = () => {
        if (location.key !== 'default') navigate(-1);
        else navigate('/v2/workspaces');
    };

    return (
        <PageHeader
            onBack={onBackHandle}
            title={`Plan: ${plan?.name}`}
            style={{ padding: '24px 0' }}
            footer={(
                <Row gutter={[40, 16]}>
                    <Col span={24}>
                        <Concepts />
                    </Col>
                    <Col span={24}>
                        <Variables />
                    </Col>
                </Row>
            )}
        />
    );
};

export { Plan };
